import { observer } from 'mobx-react-lite';
import { IconButton } from '@fluentui/react/lib/Button';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import CheckmarkFilled from 'owa-fluent-icons-svg/lib/icons/CheckmarkFilled';
import loc from 'owa-localize';
import * as React from 'react';
import {
    markAsNotCompletedLabel,
    markAsCompletedLabel,
} from './CommonTodoViewStrings.locstring.json';

import styles from './CompleteCheckbox.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface CompleteCheckboxProps {
    isComplete: boolean;
    onToggleComplete?: () => any;
    checkboxRootClassName?: string;
    checkboxClassName?: string;
    isDisabled?: boolean;
    disabledTitleResourceId?: string;
    useNativeTooltip?: boolean;
}

export default observer(function CompleteCheckbox({
    isComplete,
    onToggleComplete,
    checkboxRootClassName,
    checkboxClassName,
    isDisabled,
    disabledTitleResourceId,
    useNativeTooltip,
}: CompleteCheckboxProps) {
    const title = isDisabled
        ? loc(disabledTitleResourceId)
        : isComplete
        ? loc(markAsNotCompletedLabel)
        : loc(markAsCompletedLabel);

    const onClick = React.useCallback(
        (evt: React.MouseEvent<unknown>) => {
            evt.stopPropagation();
            if (isDisabled) {
                return;
            }
            if (onToggleComplete) {
                onToggleComplete();
            }
        },
        [onToggleComplete]
    );

    return (
        <TooltipHost content={!useNativeTooltip ? title : undefined}>
            <IconButton
                className={classNames(styles.checkBox, checkboxRootClassName, {
                    completed: isComplete,
                })}
                iconProps={{
                    iconName: CheckmarkFilled,
                    className: classNames(styles.checkMarkCircle, checkboxClassName, {
                        [styles.disabledCheckMarkCircle]: isDisabled,
                    }),
                }}
                title={useNativeTooltip ? title : undefined}
                aria-label={title}
                onClick={onClick}
                checked={isComplete}
                toggle={true}
                role="checkbox"
                aria-checked={isComplete}
                disabled={isDisabled}
            />
        </TooltipHost>
    );
});
